import { render } from "./AmazonIcon.vue?vue&type=template&id=fd822e92"
const script = {}

import exportComponent from "/home/datakepler/public_html/deploy-cache/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__